<script lang="ts">
const __DsBlock = {
	type: 'container',
	icon: 'lucide:minus',
	category: 'layout',
	slots: ['default'],
	options: [
		{
			name: 'align',
			label: '$t:blocks.common.props.align',
			type: 'enum',
			values: ['start', 'center', 'end', 'baseline', 'stretch'],
		},
		{
			name: 'justify',
			label: '$t:blocks.common.props.justify',
			type: 'enum',
			values: ['start', 'center', 'end', 'between', 'around', 'evenly', 'stretch'],
		},
		{
			name: 'vertical',
			label: '$t:blocks.common.props.vertical',
		},
		{
			name: 'wrap',
			label: '$t:blocks.common.props.wrap',
		},
	],
}
</script>
<script lang="ts" setup>
import { computed, provide, watch } from 'vue';
import { defineBlock, horizontalLayoutKey, useBlockInEditorContext } from '#layers/block-engine/public';

type SimpleLayoutAlign = 'start' | 'center' | 'end' | 'baseline' | 'stretch';
type SimpleLayoutJustify = 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly' | 'stretch';

const props = withDefaults(defineProps<{
	align?: SimpleLayoutAlign;
	justify?: SimpleLayoutJustify;
	vertical?: boolean;
	wrap?: boolean;
}>(), {
	align: 'center',
	justify: 'start',
});

;

provide(horizontalLayoutKey, () => !props.vertical);

// Update block editor layout when a layouting prop changes

const { triggerLayoutUpdate, slotIsEmpty } = useBlockInEditorContext();

const isEmpty = computed(() => slotIsEmpty());

watch(props, () => {
	triggerLayoutUpdate();
}, {
	deep: true,
});
</script>

<template>
	<div
		class="flex gap-(--block-spacing)"
		:class="{
			[`items-${align}`]: align,
			[`justify-${justify}`]: justify,
			'flex-col': vertical,
			'flex-wrap': wrap,
			'justify-center rounded-lg border border-dashed border-default p-(--block-spacing)': isEmpty,
		}"
	>
		<slot />
	</div>
</template>
